import request from "./request";
import { jwtDecode } from "./jwt";
import { getToken } from "./token";

/**
 * 直接呼叫 API 的輕量包裝（與 components/task/* 既有慣例一致）。
 * 後端一律回傳 { res_code, res_msg, data: <JWT payload> }，這裡自動解碼取出 data。
 *
 * 適用於「頁面內的細部操作」（勾選 DoD、送出審核、拖拉改狀態…）；
 * 需要進 redux 的清單資料請走 services/ + sagas/。
 */

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });
const authForm = () => ({
  headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
});
const authJson = () => ({
  headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "application/json" },
});

const dec = (res) => {
  const d = jwtDecode(res?.data);
  return d?.data;
};

export async function apiGet(url, params) {
  const res = await request.get(url, params || null, auth());
  return dec(res);
}

/**
 * body 為 FormData 或普通物件（自動轉 FormData）。
 *
 * options 疊在預設設定之上，給「跟其他請求不一樣」的少數端點用 —— 目前只有工項匯入：
 * axios 實例的 timeout 寫死 60 秒（request.js），一次寫入上百筆工項跑得比它久，
 * 而 axios 放棄不會停掉伺服器，使用者會看到「失敗」但資料其實已經寫進去了。
 * headers 另外合併而不是整個覆蓋，才不會有人只想改 timeout 就把 Authorization 弄不見。
 */
export async function apiPostForm(url, body, options) {
  const fd = body instanceof FormData ? body : toForm(body);
  const base = authForm();
  const cfg = {
    ...base,
    ...(options || {}),
    headers: { ...base.headers, ...((options || {}).headers || {}) },
  };
  const res = await request.post(url, fd, cfg);
  return dec(res);
}

export async function apiPutForm(url, body) {
  const fd = body instanceof FormData ? body : toForm(body);
  const res = await request.put(url, fd, authForm());
  return dec(res);
}

export async function apiPostJson(url, body) {
  const res = await request.post(url, body, authJson());
  return dec(res);
}

export async function apiPutJson(url, body) {
  const res = await request.put(url, body, authJson());
  return dec(res);
}

export async function apiDelete(url, params) {
  const res = await request.delete(url, params || null, auth());
  return dec(res);
}

/** 物件 → FormData（略過 undefined / null） */
export function toForm(obj = {}) {
  const fd = new FormData();
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    fd.append(k, v);
  });
  return fd;
}

/** 目前登入者帳號（自 JWT） */
export function currentAccount() {
  try {
    const t = getToken();
    if (!t) return "";
    const payload = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.account || payload.Account || "";
  } catch (e) {
    return "";
  }
}
